/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: false // Set to false to use static SVG
};

const greeting = {
  username: "Roberto Capolongo",
  title: "Ciao, sono Roberto",
  subTitle: emoji(
    "Sono un esperto di Cybersecurity e Intelligenza Artificiale, con una solida formazione accademica in Informatica e una forte passione per l’innovazione tecnologica. La mia passione per l’informatica nasce fin da bambino, quando trascorrevo ore a esplorare computer, software e sistemi operativi, cercando di comprenderne il funzionamento e sperimentando nuove soluzioni. Questa curiosità si è trasformata nel tempo in un percorso di studio e di ricerca che mi ha portato a specializzarmi nei settori della sicurezza informatica e dell’intelligenza artificiale. Nel corso della mia carriera ho sviluppato competenze nell’analisi e nella protezione dei sistemi informatici, nel machine learning, nell’analisi dei dati e nella progettazione di soluzioni intelligenti per affrontare le sfide della trasformazione digitale. Sono particolarmente interessato alle applicazioni dell’AI in ambito cybersecurity, con un focus sulla rilevazione delle minacce, l’autenticazione continua e la protezione delle identità digitali. Credo nell’apprendimento continuo, nella ricerca scientifica e nell’innovazione come strumenti fondamentali per costruire tecnologie più sicure, affidabili e capaci di generare valore per persone e organizzazioni."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1TUJxBJW9p5zkb-xCtN1mEUvkGzgW6jom/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/RobertoCapo7",
  linkedin: "https://www.linkedin.com/in/roberto-capolongo-a68515238?utm_source=share_via&utm_content=profile&utm_medium=member_ios",
  gmail: "dott.robertocapolongo@gmail.com",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "Skills",
  skills: [
    emoji(
      "⚡ Esecuzione di Vulnerability Assessment e Penetration Testing per identificare e mitigare le falle di sicurezza"
    ),
    emoji(
      "⚡ Analisi avanzata dei malware e applicazione di tecniche di Informatica Forense per l'investigazione degli incidenti"
    ),
    emoji(
      "⚡ Progettazione e implementazione di architetture di Network Security per la protezione delle infrastrutture IT"
    ),
    emoji(
      "⚡ Integrazione di modelli di Machine Learning per il rilevamento proattivo delle minacce e difesa da attacchi avversari (Adversarial ML)"
    ),
    emoji(
      "⚡ Gestione del rischio informatico e consulenza per l'adeguamento alle normative sulla protezione dei dati (GDPR)"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "Java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "Crittografia",
      fontAwesomeClassname: "fas fa-lock"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "C",
      fontAwesomeClassname: "fas fa-code"
    },
    {
      skillName: "C++",
      fontAwesomeClassname: "fas fa-file-code"
    },
    {
      skillName: "C#",
      fontAwesomeClassname: "fab fa-microsoft" // Spesso si usa il logo Windows/Microsoft per C#
    },
    {
      skillName: "Android",
      fontAwesomeClassname: "fab fa-android"
    },
    {
      skillName: "Unity",
      fontAwesomeClassname: "fab fa-unity"
    },
    {
      skillName: "Matlab",
      fontAwesomeClassname: "fas fa-square-root-alt" // Simbolo matematico, perfetto per Matlab
    },
    
    // --- ARTIFICIAL INTELLIGENCE ---
    {
      skillName: "Machine Learning",
      fontAwesomeClassname: "fas fa-brain" // Il cervello meccanico
    },
    {
      skillName: "Deep Learning",
      fontAwesomeClassname: "fas fa-network-wired" // Ricorda la struttura di una rete neurale
    },
    {
      skillName: "Adversarial ML",
      fontAwesomeClassname: "fas fa-robot" // Un robot per rappresentare l'IA avversaria
    },

    // --- CYBERSECURITY & FORENSICS ---
    {
      skillName: "Informatica Forense",
      fontAwesomeClassname: "fas fa-fingerprint" // L'impronta digitale per l'investigazione
    },
    {
      skillName: "Network Security",
      fontAwesomeClassname: "fas fa-shield-alt" // Lo scudo, simbolo universale della sicurezza
    },
    {
      skillName: "Analisi dei Malware",
      fontAwesomeClassname: "fas fa-bug" // Il classico "insetto/bug" per i virus
    },
    {
      skillName: "Penetration Testing",
      fontAwesomeClassname: "fas fa-user-secret" // L'icona dell'hacker/agente segreto
    },

    // --- COMPLIANCE E MANAGEMENT ---
    {
      skillName: "GDPR",
      fontAwesomeClassname: "fas fa-user-shield" // Scudo sull'utente per la privacy dei dati
    },
    {
      skillName: "Gestione del Rischio",
      fontAwesomeClassname: "fas fa-clipboard-check" // La spunta sul blocco note per le procedure di rischio
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Università degli Studi Aldo Moro di Bari",
      logo: require("./assets/images/uniba.png"),
      subHeader: "Laurea Magistrale in Sicurezza Informatica",
      duration: "Settembre 2024 - Luglio 2026",
      desc: "Votazione 110/110 e Lode e Menzione Speciale",
      
    },
    {
      schoolName: "Università degli Studi Aldo Moro di Bari",
      logo: require("./assets/images/uniba.png"),
      subHeader: "Laurea Triennale in Informatica",
      duration: "Settembre 2020 - Aprile 2024",
      desc: "Votazione 104/110",
    },
    {
      schoolName: "Istituto di Istruzione Superiore Augusto Righi Cerignola - FG",
      logo: require("./assets/images/augustorighi.png"),
      subHeader: "Liceo Scientifico Opzione Scienze Applicate",
      duration: "Settembre 2015 - Giugno 2020",
      desc: "Votazione 80/100",
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Cybersecurity, Forensics & Pentesting",
      progressPercentage: "80%" 
    },
    {
      Stack: "Artificial Intelligence & Machine Learning",
      progressPercentage: "80%"
    },
    {
      Stack: "Programming (C++, C#, Python, Java)",
      progressPercentage: "90%"
    },
    {
      Stack: "Compliance, GDPR & Risk Management",
      progressPercentage: "90%"
    },
    {
      Stack: "Software & App Development (Android, Unity)",
      progressPercentage: "90%"
    },
    {
      Stack: "Inglese",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Tirocinante",
      company: "Vantia S.R.L",
      companylogo: require("./assets/images/vantia.png"),
      date: "Marzo 2026 – Settembre 2026",
      desc: "Attività di R&D in ambito Artificial Intelligence e Cybersecurity",
    },
    {
      role: "Docente Multimediale",
      company: "ERSAF",
      companylogo: require("./assets/images/ersaf.jpg"),
      date: "Luglio 2022 – Settembre 2022",
      desc: "Creazione di nuovi moduli per patente europea informatica (ECDL)",
    },
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/saayaHealthLogo.webp"),
      projectName: "Saayahealth",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://saayahealth.com/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/nextuLogo.webp"),
      projectName: "Nextu",
      projectDesc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
      footerLink: [
        {
          name: "Visit Website",
          url: "http://nextu.se/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Certificazioni "),

  achievementsCards: [
    {
      title: "STATO MAGGIORE DELLA DIFESA - CYBERCHALLENGE 2025",
      subtitle:
        "Competizione nazionale di cybersecurity organizzata dallo Stato Maggiore della Difesa, dimostrando eccellenza nelle competenze di sicurezza informatica e difesa digitale.",
      image: require("./assets/images/stato.jpg"),
      imageAlt: "Stato Maggiore della Difesa - CyberChallenge 2025",
      footerLink: [
      ]
    },
    {
      title: "EIPAS CERTIFICATION",
      subtitle:
        "EIPASS 7 Moduli User, certificazione riconosciuta a livello europeo che attesta competenze digitali avanzate, tra cui sicurezza informatica, gestione dei dati e utilizzo di software professionali.",
      image: require("./assets/images/eipass_share.png"),
      imageAlt: "EIPAS Certification",
      footerLink: [

      ]
    },

    {
      title: "ESB ENGLISH CERTIFICATION",
      subtitle: "ESB C1 Advanced English Certification, certificazione che attesta una competenza linguistica avanzata in inglese, dimostrando capacità di comunicazione efficace in contesti professionali e accademici.",
      image: require("./assets/images/ESB.jpg"),
      imageAlt: "ESB English Certification",
      footerLink: [
       
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Curriculum Vitae",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contattami"),
  subtitle:
    "Hai un progetto in mente o vuoi semplicemente fare due chiacchiere? Non esitare a contattarmi.",
  number: "+92-0000000000",
  email_address: "saadpasta70@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
